import axios from 'axios';
import config from '../config';

const API_HOST = config.API_URL;

const headers = {
  accept: 'application/json',
  'Content-Type': 'application/json',
};

export const auctionService = {
  getAll,
  getById,
  search,
  create,
  update,
  remove,
  preview,
};

function getAll() {
  return axios.get(`${API_HOST}/api/Auction`, { headers }).then((res) => res.data);
}

function getById(id) {
  return axios.get(`${API_HOST}/api/Auction/${id}`, { headers }).then((res) => res.data);
}

function search(criteria = {}) {
  const payload = {
    yahooAccount: criteria.yahooAccount || null,
    status: criteria.status || null,
    searchText: criteria.searchText || null,
    fromDate: criteria.fromDate || null,
    toDate: criteria.toDate || null,
    pageIndex: criteria.pageIndex ?? 0,
    pageSize: criteria.pageSize ?? 20,
  };

  return axios
    .post(`${API_HOST}/api/Auction/Search`, payload, { headers })
    .then((res) => res.data);
}

function create(item) {
  return axios.post(`${API_HOST}/api/Auction`, item, { headers }).then((res) => res.data);
}

function update(id, item) {
  return axios.put(`${API_HOST}/api/Auction/${id}`, item, { headers }).then((res) => res.data);
}

function remove(id) {
  return axios.delete(`${API_HOST}/api/Auction/${id}`, { headers }).then((res) => res.data);
}

function preview({ productUrl, yahooAccount }) {
  return axios
    .post(
      `${API_HOST}/api/Auction/Preview`,
      {
        productUrl,
        yahooAccount: yahooAccount || null,
      },
      { headers }
    )
    .then((res) => res.data);
}
